import { render, staticRenderFns } from "./SchoolHomePeriodInfo.vue?vue&type=template&id=5b2e335b&scoped=true&"
import script from "./SchoolHomePeriodInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolHomePeriodInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolHomePeriodInfo.vue?vue&type=style&index=0&id=5b2e335b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e335b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VFlex,VLayout,VSpacer,VToolbar,VToolbarTitle})
